import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { SelectOption } from '@lib/components/Select/types';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import styles from '../Select.module.scss';

export default function ChipOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti, options } = restProps;
  const value = _get(restProps, 'value', '');
  const fullWidthMenu = _get(restProps, 'selectProps.fullWidthMenu');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const color = colorToChipType(
    _get(selectedOption, ['data', 'color']) ||
      _get(selectedOption, 'color') ||
      ChipTypes.chipGray,
  );
  const leftIcon = _get(selectedOption, ['data', 'leftIcon'], 'circle');
  const leftIconComponent = _get(selectedOption, ['data', 'leftIconComponent']);
  const leftIconSize = _get(selectedOption, ['data', 'leftIconSize']);
  const leftIconSymbolsOutlined = _get(selectedOption, [
    'data',
    'leftIconSymbolsOutlined',
  ]);
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(
        styles.chipCircleOption,
        styles.entityOptionWithLeftIcon,
        {
          active: isSelected,
          [styles.optionWithCheckbox]: isMulti,
          [styles.optionOneLine]: fullWidthMenu === false,
        },
      )}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.chipOptionIcon}>
        <Chip
          leftIcon={leftIconComponent ? undefined : leftIcon}
          leftIconSize={leftIconSize}
          leftIconComponent={leftIconComponent}
          type={color}
          size={ChipSizes.smallLeftIconOnly}
          leftIconSymbolsOutlined={leftIconSymbolsOutlined}
        />
      </span>
      {children}
    </DefaultSelectComponents.Option>
  );
}
